import { createSelector } from 'reselect';

import type { AppState } from 'types/app';

export const selectReturns = (state: AppState) => state.returns;

export const selectBoxInfo = (state: AppState) => selectReturns(state)?.boxInfo;

export const selectReturnItemCount = createSelector(
  selectBoxInfo,
  boxInfo => boxInfo && Object.values(boxInfo).reduce((itemCount, box) => itemCount + box.items.length, 0)
);
